import { useState, useRef, useCallback } from 'react';

export interface IUsePopUpWindow {
  isOpenPopupWindow: boolean;
  openPopupWindow: (url: string, onClose: () => void) => Window | null | undefined;
  closePopupWindow: () => void;
}

function usePopupWindow(): IUsePopUpWindow {
  const popupWindowRef = useRef<Window | null | undefined>();
  const [isOpenPopupWindow, setIsOpenPopupWindow] = useState(false);

  const listenPopupWindow = useCallback(
    (onClose) => {
      const pollTimer = window.setInterval(() => {
        // !== is required for compatibility with Opera
        if (popupWindowRef.current?.closed !== false) {
          window.clearInterval(pollTimer);
          setIsOpenPopupWindow(false);
          onClose();
        }
      }, 200);
    },
    [popupWindowRef.current],
  );

  const open = (url: string) => {
    const params = `scrollbars=yes,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=850,height=700,left=250,top=150`;

    return window.open(url, 'oysterCheckoutPopupWindow', params);
  };

  const openPopupWindow = (url: string, onClose: () => void) => {
    popupWindowRef.current = open(url);
    setIsOpenPopupWindow(true);
    listenPopupWindow(onClose);
    return popupWindowRef.current;
  };

  const closePopupWindow = () => {
    popupWindowRef.current?.close();
  };

  return {
    isOpenPopupWindow,
    openPopupWindow,
    closePopupWindow,
  };
}
export default usePopupWindow;
